import React from 'react';

const DefaultPage = () => {
    return (
        <div>
            
        </div>
    )
}

export default DefaultPage;